<script setup lang="ts">
const props = defineProps<{
  size?: 'sm' | 'md' | 'lg'
  title?: string
  modelValue: boolean
  confirmFn?: () => void
  cancelFn?: () => void
}>()

const emit = defineEmits(['update:modelValue'])

const value = computed({
  get() {
    return props.modelValue
  },
  set(value: boolean) {
    emit('update:modelValue', value)
  }
})

function close() {
  value.value = false
}
</script>

<template>
  <n-modal
    v-model:show="value"
    :mask-closable="false"
    transform-origin="center"
    :z-index="30001"
    to="body"
    class="m-modal"
    :class="{
      'm-modal--sm': size === 'sm',
      'm-modal--md': size === 'md',
      'm-modal--lg': size === 'lg'
    }"
  >
    <div class="m-modal__body">
      <div v-if="title" class="m-modal__title">{{ title }}</div>
      <button type="button" class="m-modal__close" @click="close">
        <n-icon size="16" color="#fff" class="bi bi-x-lg" />
      </button>
      <slot />
      <div v-if="cancelFn || confirmFn" class="m-modal__action">
        <n-button v-if="cancelFn" size="small" @click="cancelFn()">
          取消
        </n-button>
        <n-button
          v-if="confirmFn"
          size="small"
          type="primary"
          @click="confirmFn()"
        >
          确定
        </n-button>
      </div>
    </div>
  </n-modal>
</template>

<style lang="scss" scoped>
.m-modal {
  width: 80vw !important;
  &--sm {
    max-width: 450px;
  }
  &--md {
    max-width: 550px;
  }
  &--lg {
    max-width: 650px;
  }
  &__close {
    position: absolute;
    height: 32px;
    width: 32px;
    right: -40px;
    top: 0;
    background-color: rgba($color: #000000, $alpha: 0.5);
    border: none;
    border-radius: 50%;
    padding: 2px;
    cursor: pointer;
  }
  &__title {
    font-size: 16px;
    font-weight: 500;
    color: #000;
    margin-bottom: 12px;
  }
  &__body {
    min-width: 120px;
    min-height: 120px;
    padding: 12px;
    background-color: #fff;
    border-radius: 8px;
  }
  &__action {
    margin-top: 12px;
    display: flex;
    justify-content: flex-end;
    > * {
      margin-left: 12px;
    }
  }
}
</style>
